import React from 'react';
import { motion } from 'framer-motion';
import '../Styles/Home.css';
import CyphrVoid from './CyphrVoid';
import Updates from '../components/Updates';
import Feature from '../components/Feature';


const Home = () => {
    return (

        <div className="home">



            <header className="header-container">
                <div className="branding">
                    <h1>Cyphr Systems</h1>
                    <p>Privacy & Simplicity Redefined</p>
                </div>
            </header>
            <Feature />

            <div className="apps-section">
                <div className="app-card">
                    <h2>Latest Updates</h2>
                    <Updates />
                </div>
            </div>

        </div>
    );
};

export default Home;
